module.exports = __webpack_public_path__ + "media/3 Poster from shreesh.2fcadfe7.mp4";